import styled from 'styled-components';
import { whiteColor, screenSize, regularFont } from '@app/styles';
import LogoUrl from '@app/assets/images/bluelogo.png';
import googleIconUrl from '@app/assets/images/google.svg';

export const Container = styled.div`
  height: calc(100% - 65px);
  position: relative;
  display: flex;
  align-items: center;
  margin-top: 65px;
  button {
    margin-bottom: 20px;
  }
  @media (${screenSize.tablet}) {
    height: calc(100% - 55px);
    margin-top: 55px;
  }
`;

export const MainLogo = styled.div`
  width: 100%;
  background-image: url(${LogoUrl});
  background-size: auto;
  background-position: center;
  background-repeat: no-repeat;
  @media (${screenSize.tablet}) {
    height: 40%;
    position: absolute;
    background-size: auto;
    background-repeat: no-repeat;
  }
`;

export const InnerContainer = styled.div`
  padding: 15px;
  width: 100%;
  box-shadow: rgb(100 112 119 / 20%) 0px 5px 10px 0px;
  @media (${screenSize.tablet}) {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: flex-end;
    position: relative;
    width: 440px;
    height: 400px;
    padding: 25px 30px;
    background: ${whiteColor};
    border-radius: 8px;
    margin: 0 auto;
  }
`;

export const ImageContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  @media (${screenSize.tablet}) {
    display: flex;
    justify-content: center;
    align-items: center;
  }
`;

export const IntroText = styled.p`
  position: relative;
  top: 14%;
  left: 0;
  width: 100%;
  text-align: center;
  line-height: 24px;
  color: grey;
  @media (${screenSize.tablet}) {
    color: ${whiteColor};
    position: relative;
    top: auto;
    padding: 0;
    margin: 50px 0;
    color: #3a435e;
    font-size: 16px;
    line-height: 24px;
  }
`;

export const Text = styled.p`
  margin-top: 0;
  font-size: 15px;
  color: #6b6f8c;
  text-align: center;
  line-height: 24px;
  ${regularFont};
  a {
    font-size: inherit;
    ${regularFont}
  }
`;
export const GoogleIcon = styled.span`
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
  width: 100%;
  background-image: url(${googleIconUrl});
  background-position: 0 center;
  background-repeat: no-repeat;
`;
